import React from 'react';

// styles
import { hideWhenNotMobile } from 'pages/WebsiteDesignsPLPV2/WebsiteDesignsPLPV2.styles';
import {
  PLPHeaderContainer,
  PLPTitleAccent1,
  SubText,
} from 'pages/WebsiteDesignsPLPV2/components/PLPHeader/PLPHeader.styles';

const PLPHeader: React.FC = () => (
  <PLPHeaderContainer data-testid="PLPHeader">
    <PLPTitleAccent1 presentation="h2">
      Wedding website <br css={hideWhenNotMobile} />
      templates &amp; designs
    </PLPTitleAccent1>
    <SubText>
      <span>
        The easiest way for guests to RSVP, shop your registry, and get updates. Choose from 200+
        exclusive, customizable designs.
      </span>
      <br />
      <span>Bonus: matching invites</span>{' '}
      <span role="img" aria-label="Heart Envelope">
        💌
      </span>
    </SubText>
  </PLPHeaderContainer>
);

export default PLPHeader;
